import React from "react";
import { Route } from "react-router-dom";

const Home = React.lazy(() => import("../modules/pages/Home"));
const Login = React.lazy(() => import("../modules/pages/Auth/Login"));
const Registration = React.lazy(() =>
  import("../modules/pages/Auth/Registration")
);

const Dashboard = React.lazy(() => import("../modules/pages/Admin/Dashboard"));
const UploadCSV = React.lazy(() => import("../modules/pages/Upload"));
const CreateProposal = React.lazy(() =>
  import("../modules/pages/Agency/CreateProposal")
);

const ApproverProposals = React.lazy(() =>
  import("../modules/pages/Approver/ProposalList")
);

const Projects = React.lazy(() => import("../modules/pages/Approver/Projects"));
const UpdateRoles = React.lazy(() =>
  import("../modules/pages/Admin/UpdateRoles")
);

const AllProjects = React.lazy(() => import("../modules/pages/Projects"));

const home = {
  path: "/",
  exact: true,
  name: "Home component",
  component: <Home />,
  roles: ["User"],
  route: Route,
};

const login = {
  path: "/auth/login",
  exact: true,
  name: "Login component",
  component: <Login />,
  roles: ["User"],
  route: Route,
};

const registration = {
  path: "/auth/register",
  exact: true,
  name: "Registration component",
  component: <Registration />,
  roles: ["User"],
  route: Route,
};

const dashboard = {
  path: "/admin/dashboard",
  exact: true,
  name: "Admin Dashboard component",
  component: <Dashboard />,
  roles: ["User"],
  route: Route,
};

const uploadCSV = {
  path: "/upload",
  exact: true,
  name: "Upload component",
  component: <UploadCSV />,
  roles: ["User"],
  route: Route,
};

const createProposal = {
  path: "/exec/proposal/create",
  exact: true,
  name: "Create Proposal component",
  component: <CreateProposal />,
  roles: ["User"],
  route: Route,
};

const approverProposals = {
  path: "/approver/proposals",
  exact: true,
  name: "Approver Proposal component",
  component: <ApproverProposals />,
  roles: ["User"],
  route: Route,
};

const projects = {
  path: "/approver/projects",
  exact: true,
  name: "Approver Proposal component",
  component: <Projects />,
  roles: ["User"],
  route: Route,
};

const updateRoles = {
  path: "/admin/updateRoles",
  exact: true,
  name: "Update Roles component",
  component: <UpdateRoles />,
  // roles: ["Admin"],
  route: Route,
};

const allProjects = {
  path: "/projects",
  exact: true,
  name: "All projects component",
  component: <AllProjects />,
  roles: ["User"],
  route: Route,
};

export const appRoutes = [
  home,
  login,
  registration,
  dashboard,
  uploadCSV,
  createProposal,
  approverProposals,
  projects,
  updateRoles,
  allProjects,
];
